var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLupa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 82L62.698 62.698M62.698 62.698C65.9997 59.3963 68.6187 55.4766 70.4056 51.1628C72.1924 46.8489 73.1121 42.2254 73.1121 37.5561C73.1121 32.8868 72.1924 28.2632 70.4056 23.9493C68.6187 19.6355 65.9997 15.7158 62.698 12.4141C59.3963 9.11244 55.4766 6.4934 51.1628 4.70654C46.8489 2.91968 42.2254 2 37.5561 2C32.8868 2 28.2632 2.91968 23.9493 4.70654C19.6355 6.4934 15.7158 9.11244 12.4141 12.4141C5.74607 19.0822 2 28.126 2 37.5561C2 46.9861 5.74607 56.0299 12.4141 62.698C19.0822 69.3661 28.126 73.1121 37.5561 73.1121C46.9861 73.1121 56.0299 69.3661 62.698 62.698Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLupa);
export default __webpack_public_path__ + "static/media/icon_lupa.dec3a79dacc931f63f9d08ed29932339.svg";
export { ForwardRef as ReactComponent };